import { Injectable } from "@angular/core";
import { CanActivate } from "@angular/router";
import { Router } from "@angular/router";

@Injectable()
export class AdminPortalAccessGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate() {
    let user = JSON.parse(sessionStorage.getItem("User"));
    if (user && user.Role === "admin") {
      return true;
    }

    this.router.navigate(["/no-access"]);
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/guard/admin-portal/admin-portal-access.guard.ts